/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeatureaitext3Inputs */

const en_aifeatureaitext3 = /** @type {(inputs: Aifeatureaitext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI texts`)
};

const de_aifeatureaitext3 = /** @type {(inputs: Aifeatureaitext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Texte`)
};

/**
* | output |
* | --- |
* | "AI texts" |
*
* @param {Aifeatureaitext3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeatureaitext3 = /** @type {((inputs?: Aifeatureaitext3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeatureaitext3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeatureaitext3(inputs)
	return de_aifeatureaitext3(inputs)
});
export { aifeatureaitext3 as "aiFeatureAiText" }